<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="ch00_fm03_title"><a id="page_iii"></a><strong>HOW <em>to</em> CHANGE MINDS</strong></h1>
<p class="subtitle"><strong>The Art of Influence without Manipulation</strong></p>
<p class="author"><strong>ROB JOLLES</strong></p>
<p class="images"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?0d600dd9